import { earningsSlice } from '../store/slice';

export const { setEarnings } = earningsSlice.actions;
